// extracted by mini-css-extract-plugin
export default {"stateBar":"CardHeaderProposta_stateBar__tfGHb","containerButtons":"CardHeaderProposta_containerButtons__TXEuO"};